import { html, css, LitElement } from 'lit-element';
import 'lm-ui-kit/src/components/uc-header-logo/uc-header-logo.define';
import '../uc-page-content';
import { atMedia, pxToRem } from '../utils';
import { mobile, desktop } from '../utils';

export class UcHeaderContainer extends LitElement {
  static get styles() {
    return css`
      :host {
        display: flex;
        box-sizing: border-box;
        height: ${pxToRem(82)};
        padding: ${pxToRem(20)} 0;
      }

      ${mobile(css`
        :host {
          height: ${pxToRem(62)};
        }
      `)}

      .header-wrap {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
      }

      .left-side,
      .right-side {
        display: flex;
        flex: 1 1 50%;
        height: 100%;
      }

      .logo {
        display: flex;
        align-items: center;
        flex: none;
        box-sizing: border-box;
        width: ${pxToRem(47)};
        height: 100%;
        padding-bottom: ${pxToRem(4)};
        margin: auto;
      }

      ${desktop(css`
        .logo {
          width: ${pxToRem(60)};
        }
      `)}
    `;
  }

  render() {
    return html`
      <uc-page-content>
        <header class="header-wrap">
          ${atMedia.notDesktop(html` <slot class="left-side" name="left-side"></slot> `)}

          <slot name="logo" class="logo">
            <uc-header-logo>
              <a href="/">
                <img src="https://leroymerlin.ru/etc/designs/elbrus/images/logo.svg" alt="Leroy Merlin" />
              </a>
            </uc-header-logo>
          </slot>

          <slot class="right-side" name="right-side"></slot>
        </header>
      </uc-page-content>
    `;
  }
}
